import type { Provider } from './api';

const KEY = 'agent-platform.conn.v1';

export interface Conn {
  baseUrl: string;
  apiKey: string;
  provider: Provider;
  model: string;
}

export const DEFAULT_CONN: Conn = {
  baseUrl: (import.meta.env.VITE_API_BASE as string | undefined) || 'http://localhost:6011',
  apiKey: '',
  provider: 'openrouter',
  model: '',
};

export function loadConn(): Conn {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return { ...DEFAULT_CONN, ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
  return DEFAULT_CONN;
}

export function saveConn(c: Conn): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(c));
  } catch {
    /* ignore */
  }
}

export type PageId =
  | 'usage'
  | 'agents'
  | 'skills'
  | 'context'
  | 'monitoring'
  | 'models';

export const PAGES: { id: PageId; label: string; icon: string }[] = [
  { id: 'usage', label: 'Usage & Budget', icon: '◷' },
  { id: 'agents', label: 'Agents', icon: '⚇' },
  { id: 'skills', label: 'Skills Hub', icon: '✦' },
  { id: 'context', label: 'Context Hub', icon: '@' },
  { id: 'monitoring', label: 'Monitoring', icon: '◴' },
  { id: 'models', label: 'Models', icon: '⚙' },
];
